import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'utils/styleUtil';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        title: {
            ...myTypography.body1,
            fontWeight: '600',
            fontSize: '24px',
            textAlign: 'center',
            opacity: '0.8'
        },
        desc: {
            ...myTypography.body1,
            fontSize: '14px',
            textAlign: 'center'
        }
    });
}

export default getSkin;
